// Up select — トップページ モジュール別計測（GA4 Measurement Protocol 直送）
// 設置: apply.py が assets/top-list-tracking.js としてアップロードし、theme.liquid から
//       {% if template == 'index' %} で読み込む（トップページ以外では実行されない）。
// 役割: トップの各モジュール（バナー/特集/ランキング/スナップ/新着/カテゴリ/読みもの）ごとに
//       view_item_list / select_item（商品リンク）、view_promotion / select_promotion（非商品リンク）
//       を GA4 プロパティ 373302901 に送信する。GTM コンテナには依存しない（checkout_funnel_pixel と同方式）。
// 検証: URL に ?tlt_debug=1 を付けると console に送信内容を出力する。
// 撤去: theme.liquid の top_list_tracking マーカーブロックを外せば即時停止（副作用なし）。
(function () {
  'use strict';

  var MEASUREMENT_ID = 'G-TFQWC7RDDH';
  // MP secret は送信専用（読み取り不可）。checkout_funnel_pixel と同一 secret を共用。
  var API_SECRET = 'SF1R4eIHT_CAcX9dEONxOw';
  var ENDPOINT =
    'https://www.google-analytics.com/mp/collect?measurement_id=' +
    MEASUREMENT_ID +
    '&api_secret=' +
    API_SECRET;

  var DEBUG = /[?&]tlt_debug=1/.test(location.search);

  // ---- GA4 セッション復元（_ga / _ga_<ID> Cookie）----
  function cookie(name) {
    var m = document.cookie.match('(?:^|; )' + name + '=([^;]*)');
    return m ? decodeURIComponent(m[1]) : '';
  }
  function readIds() {
    var clientId = null;
    var sessionId = null;
    var m1 = cookie('_ga').match(/GA\d\.\d\.(\d+\.\d+)/);
    if (m1) clientId = m1[1];
    var m2 = cookie('_ga_' + MEASUREMENT_ID.replace('G-', '')).match(/GS\d\.\d\.(\d+)/);
    if (m2) sessionId = m2[1];
    return { clientId: clientId, sessionId: sessionId };
  }

  function send(name, params) {
    var ids = readIds();
    if (!ids.clientId) return; // GA 未ロード/拒否環境ではゴーストセッションを作らない
    params = params || {};
    params.engagement_time_msec = 1;
    if (ids.sessionId) params.session_id = ids.sessionId;
    var payload = {
      client_id: ids.clientId,
      non_personalized_ads: true,
      events: [{ name: name, params: params }],
    };
    if (DEBUG) console.log('[tlt]', name, params);
    try {
      navigator.sendBeacon(ENDPOINT, JSON.stringify(payload));
    } catch (e) { /* no-op */ }
  }

  // ---- モジュール定義 ----
  // matches: クリックされた <a> がこのモジュールに属するかの判定（closest セレクタ）
  // container: 表示計測（IntersectionObserver）対象。null なら表示計測なし
  // promo: true なら非商品モジュール（view/select_promotion で送る）
  var MODULES = [
    // 260721 修理: 旧 matches='a[href*="select_top="]' はバナー実装と不一致だった。
    // スライドは静的レンダリングで select_top= を持たず(クリックは slick フォールバックで
    // 拾えていた)、view 側はドロワー内の無関係な select_top= リンク(はじめての方へ)を
    // 掴んで非表示要素を観測 = view 永遠に 0。実コンテナ .slick-carousel-wrapper に変更。
    { list: 'top_banner_slider', matches: '.slick-carousel-wrapper a', container: '.slick-carousel-wrapper', promo: false },
    { list: 'top_feature',       matches: '#tss .ed a',            container: '#tss .ed',      promo: true },
    { list: 'top_ranking',       matches: '#tss .car.c5 a',        container: '#tss .car.c5',  promo: false },
    { list: 'top_snap',          matches: '#tss .car.c4 a',        container: '#tss .car.c4',  promo: false },
    { list: 'top_new_arrivals',  matches: '#tss .car.c6 a',        container: '#tss .car.c6',  promo: false },
    { list: 'top_category',      matches: '#tss .catgrid a',       container: '#tss .catgrid', promo: true },
    { list: 'top_stories',       matches: '#tss .arts a',          container: '#tss .arts',    promo: true },
    { list: 'top_seeall',        matches: '#tss .seeall a',        container: null,            promo: true },
  ];

  function productHandle(href) {
    var m = (href || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }
  function pathOf(href) {
    try { return new URL(href, location.origin).pathname; } catch (e) { return href || ''; }
  }
  function itemNameOf(a) {
    var el = a.querySelector('.pr-nm, .sl, .ed-t, .cl, .at');
    var t = el ? el.textContent : '';
    if (!t) {
      var img = a.querySelector('img');
      t = (img && img.getAttribute('alt')) || a.textContent || '';
    }
    return t.replace(/\s+/g, ' ').trim().slice(0, 100);
  }
  function listByCarClass(el) {
    if (!el) return null;
    if (el.classList.contains('c5')) return 'top_ranking';
    if (el.classList.contains('c4')) return 'top_snap';
    if (el.classList.contains('c6')) return 'top_new_arrivals';
    return null;
  }
  function findMod(list) {
    for (var i = 0; i < MODULES.length; i++) if (MODULES[i].list === list) return MODULES[i];
    return null;
  }
  function moduleOf(a) {
    for (var i = 0; i < MODULES.length; i++) {
      var mod = MODULES[i];
      if (mod.matches.charAt(0) === 'a') {
        // 属性セレクタ（バナー）: a 自身が該当するか
        if (a.matches(mod.matches)) return mod;
      } else if (a.closest(mod.matches.replace(/ a$/, ''))) {
        return mod;
      }
    }
    // モバイルのスワイプ連動キャプション（.tss-cap は .car の兄弟要素として後挿入される）
    if (a.classList.contains('tss-cap')) {
      var prev = a.previousElementSibling;
      while (prev && !prev.classList.contains('car')) prev = prev.previousElementSibling;
      var list = listByCarClass(prev);
      if (list) return findMod(list);
    }
    // トップバナー（slick クローン等で select_top が付かない保険）
    if (a.closest('[id*="slick" i], .custom-slick-slider')) return MODULES[0];
    return null;
  }

  // ---- クリック計測（document 委譲: slick のクローンスライドにも効く）----
  // .car のドラッグ抑止 click ハンドラ（capture で stopPropagation）が先に効くため、
  // ドラッグ由来の誤クリックはここまで届かない。
  document.addEventListener('click', function (ev) {
    var a = ev.target && ev.target.closest ? ev.target.closest('a[href]') : null;
    if (!a) return;
    var mod = moduleOf(a);
    if (!mod) return;
    var handle = productHandle(a.getAttribute('href'));
    if (handle) {
      // 商品リンクはモジュール問わず select_item（item_list_name = モジュール名）
      send('select_item', {
        item_list_id: mod.list,
        item_list_name: mod.list,
        items: [{ item_id: handle, item_name: itemNameOf(a) }],
      });
    } else {
      // 非商品リンク（記事/カテゴリ/すべて見る等）は select_promotion
      send('select_promotion', {
        items: [{
          promotion_id: mod.list,
          promotion_name: mod.list,
          creative_name: pathOf(a.getAttribute('href')).slice(0, 100),
        }],
      });
    }
  }, false);

  // ---- 表示計測（モジュールが 30% 見えたら 1 回だけ）----
  function collectItems(mod) {
    var sel = mod.matches;
    var anchors = document.querySelectorAll(sel.charAt(0) === 'a' ? sel : sel.replace(/ a$/, ' a[href]'));
    var seen = {};
    var items = [];
    for (var i = 0; i < anchors.length && items.length < 10; i++) {
      var h = productHandle(anchors[i].getAttribute('href'));
      if (!h || seen[h]) continue;
      seen[h] = 1;
      items.push({ item_id: h, item_name: itemNameOf(anchors[i]), index: items.length + 1 });
    }
    return items;
  }
  function sendView(mod) {
    if (mod.promo) {
      send('view_promotion', {
        items: [{ promotion_id: mod.list, promotion_name: mod.list }],
      });
    } else {
      var items = collectItems(mod);
      if (!items.length) return;
      send('view_item_list', {
        item_list_id: mod.list,
        item_list_name: mod.list,
        items: items,
      });
    }
  }
  // 260721 修理: banner_slider は slick 初期化が DOMContentLoaded より遅く要素未生成で
  // 観測対象から漏れ、seeall は container 未定義で表示計測が未実装だった（click 側は
  // 委譲のため両方とも動いていた = view だけ 0 の不具合）。
  // → 観測対象の解決を最大15秒リトライ + seeall はリンク要素ごとに view_promotion を送る。
  function observeViews() {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var d = en.target.__tltView;
        io.unobserve(en.target);
        if (!d || d.sent) return;
        d.sent = true;
        if (d.creative) {
          send('view_promotion', {
            items: [{
              promotion_id: d.mod.list,
              promotion_name: d.mod.list,
              creative_name: d.creative,
            }],
          });
        } else {
          sendView(d.mod);
        }
      });
    }, { threshold: 0.3 });

    var resolved = {}; // mod.list -> true（観測開始済み）
    function tryResolve() {
      MODULES.forEach(function (mod) {
        if (resolved[mod.list]) return;
        if (mod.list === 'top_seeall') {
          // 各モジュールの「すべて見る」を個別観測（creative_name = リンク先パス）
          var els = document.querySelectorAll('#tss .seeall');
          if (!els.length) return; // 未生成 → リトライ
          resolved[mod.list] = true;
          for (var i = 0; i < els.length; i++) {
            var link = els[i].querySelector('a[href]');
            els[i].__tltView = {
              mod: mod,
              creative: link ? pathOf(link.getAttribute('href')).slice(0, 100) : 'unknown',
            };
            io.observe(els[i]);
          }
          return;
        }
        if (!mod.container) {
          resolved[mod.list] = true; // 表示計測対象外
          return;
        }
        var el = document.querySelector(mod.container);
        if (!el) return; // 未生成 → リトライ
        resolved[mod.list] = true;
        el.__tltView = { mod: mod };
        io.observe(el);
      });
    }

    tryResolve();
    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      tryResolve();
      var done = MODULES.every(function (m) { return resolved[m.list]; });
      if (done || attempts >= 15) clearInterval(timer);
    }, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeViews);
  } else {
    observeViews();
  }
})();
